export const authStatus = [
    "正式", "未付款", "禁用", "试用", "加密狗","离线"
]
export const product = {
    "1": "FastBI",
    "2": "C9"
}

//"13":"FastBI基础版",
export const edition = {
    "1":{"11":"FastBI标准平台","12":"FastBI高级版","14":"FastBI企业版"},
    "2":{"21":"C9基础版","22":"C9标准版","23":"C9高级版"}
}
export const agentType = [
    "直销", "区域总代", "金牌代理", "银牌代理", "铜牌代理", "项目合作", "OEM合作", "战略合作", "内嵌集成", "其他合作"
]
export const payType = [
    "专用币","专用币优先","通用币"
]
export const serviceStaffType = {
    "0":"售前顾问",
    "1":"实施经理",
    "2":"项目经理"
}


// WEBPACK FOOTER //
// ./src/utils/dataDict.js